import { PrizeTypes } from "../brandVariables.types";

// CS2 Time Trial co-lab (KC0209) — keep in sync with CHALLENGE_PRIZE in the
// keychron-time-trial tracker (gt-desktop). Shared by the CSGO boards
// (KEYCHRON, KEYCHRON-vertical, KEYCHRON-time-trail), which all read the same
// tenant + challenges as the tracker, so they must advertise the same prize.
export const keychronPrize: PrizeTypes = {
  content: "Win a ",
  nameOf: "Keychron Q3 Pro 80% QMK Wireless Gateron Red", // will be marked in color
  typeOfItem: "", // will be added after nameOf

  emptyPrize:
    "https://ik.imagekit.io/gmng/keychron-kzk8f/trackerImages/Q3P-M1-BO.png",
};
